var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',[_c('h4',{staticClass:"payment-header-title",domProps:{"innerHTML":_vm._s(_vm.$t(
      `donation.${_vm.paymentMethod}_custom_header`,
      'Donation initiated via {paymentMethod}',
      { paymentMethod: _vm.paymentMethod }
    ))}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }